import React from "react";
import useStyles from "../app/styles";
import { Box, Tooltip, Button } from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
// import Button from "@material-ui/core/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const RegularTable = (props) => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [page, setPage] = React.useState(1);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const classes = useStyles();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChooseTest = () => {
    document.getElementById("selectOptions").scrollIntoView();
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function GoToFirst() {
    return (
      <>
        <FirstPageIcon />
        <b style={{ fontSize: "18px" }}>First</b>
      </>
    );
  }
  function GoToLast() {
    return (
      <>
        <b style={{ fontSize: "18px" }}>Last</b>
        <LastPageIcon />
      </>
    );
  }
  function GoToNext() {
    return (
      <>
        <b style={{ fontSize: "18px" }}>Next</b>
        <NavigateNextIcon />
      </>
    );
  }
  function GoToPrev() {
    return (
      <>
        <NavigateBeforeIcon />
        <b style={{ fontSize: "18px" }}>Prev</b>
      </>
    );
  }

  const totalPagesCount = () =>
    parseInt(props.data.length / rowsPerPage) +
    (props.data.length % rowsPerPage > 0 ? 1 : 0);

  return (
    <Box p={2} sx={{ width: "100%" }}>
      <div className={classes.tableHeader}>
        <Button
          variant="contained"
          className={classes.chooseTestButton}
          onClick={handleChooseTest}
        >
          Choose a New Test
        </Button>
        <Pagination
          count={totalPagesCount()}
          page={page}
          onChange={handleChangePage}
          color="secondary"
          size="large"
          showFirstButton={true}
          showLastButton={true}
          renderItem={(item) => (
            <PaginationItem
              components={{
                first: GoToFirst,
                last: GoToLast,
                next: GoToNext,
                previous: GoToPrev,
              }}
              {...item}
            />
          )}
        />
      </div>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table aria-labelledby="tableTitle" size={dense ? "small" : "medium"}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell className={classes.tableHeadCell}>
                  Company Name
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  Institution types
                </TableCell>
                <TableCell className={classes.tableHeadCell}>
                  Locations Served
                </TableCell>
                <TableCell className={classes.tableHeadCell}>Website</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.map((row, index) => (
                <TableRow
                  className={classes.tableBodyRow}
                  key={row.name}
                  sx={
                    index % 2 === 0
                      ? {
                          height: "48px",
                          "&:last-child td, &:last-child th": { border: 0 },
                        }
                      : {
                          height: "48px",
                          background: "#FAFAFA 0% 0% no-repeat padding-box",
                          "&:last-child td, &:last-child th": { border: 0 },
                        }
                  }
                >
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell>{row.institution_types}</TableCell>
                  <TableCell>{row.locations_served}</TableCell>
                  <TableCell>
                    <a href={row.website} target="_blank" rel="noopener noreferrer">{row.website}</a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default RegularTable;
